import React from 'react'
import {Link} from 'react-router-dom'

import LandingPageHeader from '../../components/Header/LandingPageHeader'
import PagesFooter from 'components/Footer/PagesFooter';

import {
  Container,
  Row,
  Col,
  // Button,
  // Card,
  // CardBody,
  // CardTitle,
  // CardFooter
} from "reactstrap";
import Advantages from 'components/mainPageComponents/Advantages'

const LandingPage = () => {
  /*const openDemo = () => {
      window.open('https://www.youtube.com/watch?v=q6lXrYGO0EA', '_blank')
  }*/

  return (
      <>
        <div id={'skipLinks'}>
          <a href={'#tresc'}>Przejdź do treści</a>
          <a href={'#login-link'}>Przejdź do logowania</a>
          <a href={'#film-link'}>Przejdź do filmu instruktażowego</a>
        </div>
        <LandingPageHeader />

        <div id={'tresc'} tabIndex={'-1'} className="">
          <div className="text-center landing-section">
            <Container>
              <Row>
                <Col className="ml-auto mr-auto" md="12">
                  {/*<h4 style={{fontWeight:"400"}}>Zarządzaj kosztami, przychodami, śledź  trendy, porównuj wartości i&nbsp;wskaźniki w&nbsp;aplikacji.</h4>
                      <h2 className="title">Aplikacja SRK</h2>
                      <h5 className="text-justify text-center">

                               Zarządzaj kosztami, przychodami, śledź  trendy, porównuj wartości i wskaźniki w aplikacji.<br/>
                              Aplikacja SRK to&nbsp;bezpłatne, nowatorskie narzędzie dla&nbsp;podmiotów leczniczych umożliwiające rozliczenie kosztów,
                               wycenę procedur medycznych, benchmarking oraz efektywne zarządzanie.

                      </h5>*/}
                  <h1 className="mt-5 title h2">Aplikacja SRK</h1>
                  <h2 className={'h4'} style={{fontWeight:"400"}}>Zarządzaj kosztami, przychodami, śledź  trendy, porównuj wartości i&nbsp;wskaźniki w&nbsp;aplikacji.</h2>
                  <h3 className="text-justify text-center h5" style={{fontWeight:"300"}}>

                    {/* Zarządzaj kosztami, przychodami, śledź  trendy, porównuj wartości i wskaźniki w aplikacji.<br/> */}
                    Aplikacja SRK to&nbsp;bezpłatne, nowatorskie narzędzie dla&nbsp;podmiotów leczniczych umożliwiające rozliczenie kosztów,
                    wycenę procedur medycznych, benchmarking oraz efektywne zarządzanie.

                  </h3>
                  <br />
                  {/*<Link to='/admin/main_page' id={'login-link'} className={'nav-link'} aria-label={'Logowanie - link otworzy stronę z logowaniem'}><Button
                        className="btn-fill btn-round" size='lg'
                        // color='danger'
                        style={{backgroundColor: "#266a64"}}
                        // href="/admin/main_page"
                        // onClick={(e) => e.preventDefault()}
                      >
                        Logowanie/Rejestracja
                      </Button>

                      </Link>*/}
                  <Link to='/auth/login' id={'login-link'} className={'nav-link d-inline-block btn-fill btn-round btn btn-primary btn-lg'} aria-label={'Logowanie - link otworzy stronę z logowaniem'}>
                    Logowanie/Rejestracja
                  </Link>
                  {/* <Button
                        className="btn-fill btn-round"
                        color="danger"
                        href="/admin/main_page"
                        // onClick={(e) => e.preventDefault()}
                      >
                        Przejdź do Panelu
                      </Button> */}
                </Col>
              </Row>
              <br />
              <br />
              <Row>
                <Col>
                  <div className="info">
                    <div className="icon" style={{color: "#266a64"}}>
                      <i title={'test'} className="nc-icon nc-single-copy-04" />
                    </div>
                    <div className="description">
                      {/*<h5 className="info-title">Wprowadzanie danych </h5>*/}
                      <h3 className="info-title h5">Wprowadzanie danych </h3>
                      <p className="description">
                        Tutaj wprowadzisz i&nbsp;zatwierdzisz dane finansowe i&nbsp;statystyczne niezbędne do&nbsp;rozliczenia kosztów.
                      </p>
                      {/* <Button
                            className="btn-link"
                            color="danger"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            See more
                          </Button> */}
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="info">
                    <div className="icon" style={{color: "#266a64"}}>
                      <i title={'test'} className="nc-icon nc-money-coins" />
                    </div>
                    <div className="description">
                      {/*<h5 className="info-title">Wycena procedur medycznych</h5>*/}
                      <h3 className="info-title h5">Wycena procedur medycznych</h3>
                      <p>
                        Tutaj dokonasz wyceny procedur poprzez elektroniczne zdefiniowanie zasobów i&nbsp;rozliczysz koszty pośrednie procedur zgodnie z&nbsp;wybraną metodą.
                      </p>
                      {/* <Button
                            className="btn-link"
                            color="danger"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            See more
                          </Button> */}
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="info">
                    <div className="icon" style={{color: "#266a64"}}>
                      <i title={'test'} className="nc-icon nc-paper" />
                    </div>
                    <div className="description">
                      {/*<h5 className="info-title">Raporty</h5>*/}
                      <h3 className="info-title h5">Raporty</h3>
                      <p>
                        Tutaj wygenerujesz w&nbsp;formie tabel i&nbsp;wykresów gotowe raporty według wybranych przez siebie kryteriów w&nbsp;dowolnych zakresach czasowych.                         </p>
                      {/* <Button
                            className="btn-link"
                            color="danger"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            See more
                          </Button> */}
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="info">
                    <div className="icon" style={{color: "#266a64"}}>
                      <i title={'test'} className="nc-icon nc-briefcase-24" />
                    </div>
                    <div className="description">
                      {/*<h5 className="info-title">Pulpit zarządczy</h5>*/}
                      <h3 className="info-title h5">Pulpit zarządczy</h3>
                      <p>
                        Tutaj wyświetlisz jednocześnie podstawowe dane finansowe z&nbsp;możliwością ich wielowymiarowej analizy, co&nbsp;wspomoże&nbsp;Cię w&nbsp;podejmowaniu decyzji zarządczych.
                      </p>
                      {/* <Button
                            className="btn-link"
                            color="danger"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            See more
                          </Button> */}
                    </div>
                  </div>
                </Col>

                <Col>
                  <div className="info">
                    <div className="icon" style={{color: "#266a64"}}>
                      <i title={'test'} className="nc-icon nc-chart-bar-32" />
                    </div>
                    <div className="description">
                      {/*<h5 className="info-title">Wskaźniki <br/>Benchmarking</h5>*/}
                      <h3 className="info-title h5">Wskaźniki <br/>Benchmarking</h3>
                      <p>
                        Tutaj porównasz swoje wskaźniki ekonomiczno-finansowe i&nbsp;statystyczne z&nbsp;innymi podmiotami w&nbsp;Polsce i&nbsp;w&nbsp;poszczególnych województwach.
                      </p>
                      {/* <Button
                            className="btn-link"
                            color="danger"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            See more
                          </Button> */}
                    </div>
                  </div>
                </Col>

              </Row>
              <div style={dividerLine}/>
              <Advantages getBackBtn={()=>{}} noCard={true} />
              <div style={dividerLine}/>
              <a id={'film-link'} href={'https://www.youtube.com/watch?v=q6lXrYGO0EA'} rel="noreferrer nofollow" aria-label={'Film instruktażowy - link otworzy nową kartę'} target={'_blank'}
                 className="btn-fill btn-round btn btn-primary btn-lg"
              >
                Zapoznaj&nbsp;się z&nbsp;filmem instruktażowym
              </a>
            </Container>
          </div>
        </div>
        <PagesFooter />
      </>
  )
}

const dividerLine = {
  borderTop: '3px solid rgb(219, 219, 219)',
  borderBottom: '4px solid rgb(219, 219, 219)',
  height: '10px',
  marginTop: '1rem',
  marginBottom: '1rem',
}

export default LandingPage
